<template>
<div id="app">

    <sidenav :delist="navlist" :class='{"leftside":true,tor:mydata.navshow,tol:!mydata.navshow}'></sidenav>

    <div :class="{vcl:true,vtor:mydata.navshow,vtol:!mydata.navshow}">

    <myheader></myheader>

    <transition name="page">
        <router-view @click.native="hidenav()" style="margin-top: 3rem;" :class="{fix:mydata.navshow}"></router-view>
    </transition>

    </div>

</div>  
</template>
<script>
import sidenav from "./lib/sidenav.vue";
import myheader from "./lib/myheader";
import nav from "./js/nav";

export default {
    name:"index",
    components:{
        sidenav,
        myheader,
    },
    data:()=>{
        return {
            count:2,
            mydata:window.mydata,
            navlist:nav,
        }
  },
  created:function(){
    this.setnav();
  },
  watch: {
      '$route': 'setnav',
    },
  methods:{
    setnav:function(){
      var path=this.$route.path;
      if(path=="/"){
        this.mydata.nav="/";
        this.mydata.header=true;
        this.mydata.back=false;
      }
    },
    hidenav:function(){
      this.mydata.navshow=false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue